<template>
  <section
    class="features-tiles section center-content-mobile"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="features-tiles-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div
                  class="features-tiles-item-image mb-12 reveal-from-right"
                  data-reveal-container=".tiles-item"
                >
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-07.svg')"
                    alt="Feature tile icon 01"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4
                  class="mt-0 mb-8 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="100"
                >
                  智慧物流
                </h4>
                <p
                  class="m-0 text-sm reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="200"
                >
                  一号线国际速递的始终致力于提升行业技术水平，不断优化系统使用体验。智能化的数据处理在您看不到的地方为您的包裹节省了可观的时间；尽心尽职的专业客服、关务、操作团队替您从头到尾地跟进您的
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div
                  class="features-tiles-item-image mb-12 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="100"
                >
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-08.svg')"
                    alt="Feature tile icon 02"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4
                  class="mt-0 mb-8 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="200"
                >
                  自营门店
                </h4>
                <p
                  class="m-0 text-sm reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="300"
                >
                  一号线国际速递全资拥有PERTH多家门店和2200平米自有操作仓库
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div
                  class="features-tiles-item-image mb-12 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="200"
                >
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-09.svg')"
                    alt="Feature tile icon 03"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4
                  class="mt-0 mb-8 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="300"
                >
                  精准面单
                </h4>
                <p
                  class="m-0 text-sm reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="400"
                >
                  我们全程使用末端面单，大幅提高送达总准确率。
                </p>
              </div>
            </div>
          </div>

       
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CFeaturesTiles",
  components: {
    CSectionHeader,
    CImage,
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: "",
        paragraph: "",
      },
    };
  },
};
</script>